import React, { FC, useCallback, useEffect, useState } from "react";
import { AdUploadFiles } from "../AdUploadFiles";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Form, Tooltip } from "antd";

import { openToast } from "../../../../Toasts";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";
import {
  getAgencyQuotesFormDataAction,
  getFilesByStageAction,
  getNoticeEmailDataAction,
  sendEmailAction,
} from "../../../../store/actions/raiseAdRequest";
import {
  detectFileIconType,
  detectProjectType,
} from "../../../AgencyFileDrop/utils";
import { IMAGE_BASE_URL } from "../../../../utilities/paths";
import Img from "../../../../components/ImageLoader/ImageLoader";
import EmailForm from "../EmailForm";
import {
  canPerformAction,
  StepNames,
} from "../../../RaiseNoticeAdRequest/utils";
import moment from "moment";
// import { AdUploadFiles } from "../AdUploadFiles";

const permittedRoles = ["admin","product-admin"];
export const ReviewAndCloseForm: FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { selectedProductId, requestId } = useParams<{
    selectedProductId: string;
    requestId: string;
  }>();
  const {
    estimatesProof,
    softCopyProof,
    reviewEmailContent,
    userRole,
    lastStepName,
    quoationApprovalFormData,
    loading,
    quoteDetailsFormData
  } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );

  const isStepAccessible = canPerformAction(
    userRole,
    permittedRoles,
    StepNames[6],
    lastStepName,
    quoationApprovalFormData.trashed_at
  );

  const [isFormValuesChanged, setIsFormValuesChanged] = useState<boolean>(
    false
  );
  const fixedBody = `<p style="margin:0">Dear Team,</p>
<p style="margin:0">We have published the Notice Ad for: Type: ${quoationApprovalFormData.request_type} **Branch Code**: ${quoationApprovalFormData.branch_code} **City**: ${quoationApprovalFormData.city}</p>
<p style="margin:0">Please find attached the Soft copies of the Ad released on ${moment(quoteDetailsFormData?.data?.[0]?.release_date).format("DD-MM-YYYY")}.</p>
`;
  useEffect(() => {
    dispatch(
      getFilesByStageAction({
        stage: "Upload Proof",
        request_id: requestId,
      })
    );
    dispatch(getAgencyQuotesFormDataAction(requestId));

    dispatch(getNoticeEmailDataAction({ requestId, stage: 7 }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isStepAccessible && !!userRole) {
      openToast("info", "You only have view access to this information.");
    }
  }, [isStepAccessible, userRole]);

  useEffect(() => {
    if (reviewEmailContent) {
      form.setFieldsValue({
        emailContent: {
          ...reviewEmailContent,
          to:
            reviewEmailContent?.to && reviewEmailContent.to.trim() !== ""
              ? reviewEmailContent.to
              : quoationApprovalFormData?.emailContent?.cc,
          cc:
            reviewEmailContent?.to && reviewEmailContent.to.trim() !== ""
              ? reviewEmailContent.cc
              : "",

          subject: `Request closed | ${quoationApprovalFormData.branch_code} | REQ-${quoationApprovalFormData?.id} |  ${quoationApprovalFormData.request_type} | Notice Ad | ${quoationApprovalFormData.city} | ${quoationApprovalFormData.state}`,
        },
      });
    }
  }, [reviewEmailContent, quoationApprovalFormData, form]);

  const handleCloseRequest = useCallback(
    (values: any) => {
      const s3_urls = [estimatesProof[0]?.file_url, softCopyProof[0]?.file_url];
      dispatch(
        sendEmailAction({
          formData: values,
          template_id: "41412754",
          stage: "7",
          s3_urls,
        })
      );
    },
    [dispatch, estimatesProof, softCopyProof]
  );

  return (
    <>
      <div className="layout-wrapper">
        {/* Scrollable Form */}
        <div className="layout-wrapper__body">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontSize: "1.8rem",
                fontWeight: 500,
              }}
            >
              Review your uploaded documents
            </div>
            <div style={{ display: "flex" }}>
              {[...(estimatesProof || []), ...(softCopyProof || [])].map(
                (file, fileIndex) => (
                  <>
                    <div key={fileIndex} style={{ maxWidth: "35rem" }}>
                      <div
                        key={fileIndex}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            bottom: "-20rem",
                            left: "2rem",
                            padding: "0.5rem",
                            background: "#FFFFFF",
                            border: "1px solid #ECEEF1",
                            borderRadius: "0.6rem",
                          }}
                        >
                          <img
                            src={detectFileIconType({
                              ...file,
                              file_url: IMAGE_BASE_URL + file.file_url,
                            })}
                            alt="DropDown Icon"
                          />
                        </div>
                      </div>
                      <div className="file_wrapper">
                        <Img
                          className=" file_image"
                          src={detectProjectType({
                            ...file,
                            file_url: IMAGE_BASE_URL + file.file_url,
                          })}
                        />
                      </div>
                      <div className="file_content_wrapper">
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <Tooltip placement="bottomRight" title={`${file.title}.${file.content_type}`}>
                            <div className="image_title">{`${file.title}.${file.content_type}`}</div>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </>
                )
              )}
            </div>
          </div>

          <div
            style={{
              margin: "2rem 0",
              display: "flex",
              gap: "1rem",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                fontSize: "1.6rem",
                fontWeight: 600,
                color: "#394455",
              }}
            >
              Send Closure Email
            </div>
            <div
              style={{
                fontSize: "1.4rem",
                fontWeight: 400,
                marginBottom: "1rem",
              }}
            >
              Soft Copy of the Notice Ad will be attached automatically to this
              email.
            </div>
            <Form
              form={form}
              className="custom-form"
              onFinish={handleCloseRequest}
              onValuesChange={() => setIsFormValuesChanged(true)}
            >
              <EmailForm
                form={form}
                fixedBody={fixedBody}
                footerMessage={reviewEmailContent?.footerMessage}
                subject={reviewEmailContent?.subject}
                isUserPermitted={isStepAccessible}
              />
            </Form>
          </div>
        </div>

        {!!isStepAccessible ? (
          <div className="layout-wrapper__footer">
            <button
              className="btn btn--purple"
              disabled={!!loading}
              onClick={() => form.submit()}
            >
              Review and close
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
